module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-contain"
  }, [_c('div', {
    staticClass: "banner-footer"
  }, [(_vm.isWeixin) ? _c('div', {
    staticClass: "banner-footer-right"
  }, [_c('input', {
    staticClass: "searchForH5",
    staticStyle: {
      "width": "24rem"
    },
    attrs: {
      "placeholder": _vm.inputPlaceholder
    },
    on: {
      "click": function($event) {
        _vm.goToSearch()
      }
    }
  })]) : _c('div', {
    staticClass: "banner-footer-right",
    staticStyle: {
      "text-align": "left",
      "margin-left": "1rem",
      "line-height": "1.6rem"
    }
  }, [_c('input', {
    staticClass: "searchForH5",
    staticStyle: {
      "width": "17rem"
    },
    attrs: {
      "placeholder": _vm.inputPlaceholder
    },
    on: {
      "click": function($event) {
        _vm.goToSearch()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "download",
    staticStyle: {
      "line-height": "1.6rem"
    },
    on: {
      "click": function($event) {
        _vm.public.downloadApp()
      }
    }
  }, [_vm._v("\n        下载APP\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-539c0914","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/taoke/Header.vue
// module id = 204
// module chunks = 2